import { Helmet } from 'react-helmet';

/**
 * Keeps the authenticated customer portal out of search results.
 *
 * public/index.html now ships `index, follow` so the public landing page can be
 * crawled; every screen behind sign-in mounts this to override that default.
 * robots.txt disallows the same routes, but a `Disallow` only stops crawling —
 * a URL linked from elsewhere can still be listed without it. This tag is what
 * actually removes it.
 */
const NoIndex = () => (
  <Helmet>
    <meta name="robots" content="noindex, nofollow" />
  </Helmet>
);

export default NoIndex;
